import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { CustomUser } from 'api';
import { IUser, updateUserState } from 'dashboard409a/states/features/user';
import { resetDashboardState as resetDashboardStateAction } from 'dashboard409a/states/store';

// This is the single legacy bridge for syncing the user and clearing session-bound dashboard Redux state.
// When dashboard no longer reads the Redux user slice, delete this hook and its callsites.
const useDashboardReduxUserSync = () => {
  const dispatch = useDispatch();

  const syncDashboardUser = useCallback(
    (userInfo: CustomUser) => {
      dispatch(updateUserState(userInfo as unknown as IUser));
    },
    [dispatch]
  );

  const resetDashboardState = useCallback(() => {
    dispatch(resetDashboardStateAction());
  }, [dispatch]);

  return {
    resetDashboardState,
    syncDashboardUser,
  };
};

export default useDashboardReduxUserSync;
